<script setup>
import { Link } from '@inertiajs/vue3';

defineProps({
    title: {
        type: String,
        required: true
    },
    subtitle: {
        type: String,
        default: ''
    },
    breadcrumbs: {
        type: Array,
        default: () => []
    },
    waveClass: {
        type: String,
        default: 'text-white dark:text-gray-900'
    }
});
</script>

<template>
    <section class="relative overflow-hidden">
        <!-- Background with Orange Gradient (Matching Homepage) -->
        <div class="absolute inset-0 bg-gradient-to-br from-orange-600 via-orange-500 to-amber-400"></div>
        
        <!-- Decorative Elements -->
        <div class="absolute inset-0 overflow-hidden pointer-events-none">
            <svg class="absolute right-0 top-0 text-white/10 w-64 h-64 -mr-16 -mt-16" fill="currentColor" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50"/></svg>
            <div class="absolute left-10 bottom-10 w-20 h-20 bg-white/10 rounded-full blur-xl"></div>
        </div>

        <div class="container mx-auto px-4 lg:px-6 xl:px-8 relative z-10 text-center py-12 md:py-16">
            <!-- Breadcrumb (Moved to Top) -->
            <div v-if="breadcrumbs.length > 0" class="flex justify-center mb-6">
                <div class="inline-flex items-center gap-2 text-xs md:text-sm text-white/90 bg-white/10 backdrop-blur-md px-4 py-1.5 rounded-full border border-white/20 shadow-sm">
                    <template v-for="(crumb, index) in breadcrumbs" :key="index">
                        <Link v-if="crumb.url" :href="crumb.url" class="hover:text-white transition-colors font-medium">{{ crumb.label }}</Link>
                        <span v-else class="text-white font-bold">{{ crumb.label }}</span>
                        
                        <i v-if="index < breadcrumbs.length - 1" class="fa fa-chevron-right text-[10px] opacity-70"></i>
                    </template>
                </div>
            </div>

            <h1 class="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-4 tracking-tight drop-shadow-sm">{{ title }}</h1>
            <p v-if="subtitle" class="text-amber-100 text-lg max-w-2xl mx-auto font-medium">{{ subtitle }}</p>
        </div>
        
        <!-- Bottom Wave/Shape (Simple curve) -->
        <div class="absolute bottom-0 left-0 right-0 transition-colors duration-300" :class="waveClass">
            <svg viewBox="0 0 1440 48" fill="currentColor" class="w-full h-auto block">
                <path d="M0,48 L1440,48 L1440,0 C1440,0 1140,48 720,48 C300,48 0,0 0,0 L0,48 Z"></path>
            </svg>
        </div>
    </section>
</template>
